export const environment = {
  production: `true`,
  launchcontrolAdminDomain: `admin.dealerteamwork.com`,
  launchcontrolApiDomain: `api.dealerteamwork.com`,
  autoDomain: `auto-api.admin.dealerteamwork.com`,
  autoPort: `443`,
  mpopDomain: `adflex-api.admin.dealerteamwork.com`,
  envName: `undefined`
};
